<template>
    <v-row>
        <v-col cols="12" md6 offset-md="0" class="pa-0">
            <span>Настройки подключения ВКонтакте</span>
            <v-divider ></v-divider>
            <v-checkbox class="pa-0 ma-1 mx-2"
                        v-model="botModel.token_vk"
                        label="Подключение бота к ВК. Сценарий"
                        readonly
                        :color="botModel.token_vk == '1' ? 'success' : 'error'"
                        true-value="1"
                        false-value="0"
                        success-text="false"
                        hide-details
            ></v-checkbox>
        </v-col>
        <v-col cols="12" md6 offset-md="0" class="pa-0">
            <v-btn color="primary" :disabled="false"
                   @click="showSelectGroupDialog(false)"
                   text
                   small
            >
                <span class="text-none">Подключить</span>
            </v-btn>
        </v-col>

        <v-col cols="12" md6 offset-md="0" class="pa-0">
            <v-checkbox class="pa-0 ma-1 mx-2"
                        v-model="botModel.token_vk_mailing"
                        label="Подключение бота к ВК. Рассылки"
                        readonly
                        color="success"
                        true-value="1"
                        false-value="0"
                        hide-details
            ></v-checkbox>
        </v-col>
        <v-col cols="12" md6 offset-md="0" class="pa-0 pb-6">
            <v-btn color="primary" :disabled="false"
                   @click="showSelectGroupDialog(true)"
                   text
                   small
            >
                <span class="text-none">Подключить</span>
            </v-btn>
        </v-col>
        <v-col cols="12" md6 offset-md="0" class="pa-0" v-show="botModel.token_vk == '1'">
            <v-text-field label="Вручную ввести код подтверждения" class="px-4" v-model="botModel.code_vk"></v-text-field>
        </v-col>
        <v-col cols="12" md6 offset-md="0" class="pa-0" v-show="botModel.token_vk == '1'">
            <v-btn color="primary" :disabled="false"
                   @click="visSettingGroupVkDialog = true"
                   text
                   small
            >
                <span class="text-none">Настроить</span>
            </v-btn>
        </v-col>
        <v-col cols="12" md6 offset-md="0" class="pa-0" v-show="botModel.token_vk == '1'">
            <v-btn color="error" :disabled="false"
                   @click="deleteCallbackServer"
                   text
                   small
            ><span class="text-none">Удалить сервер</span></v-btn>
        </v-col>
        <v-col cols="12" md6 offset-md="0" class="pa-0" v-show="botModel.token_vk == '1'">
            <v-btn color="primary" :disabled="false"
                   :href="'https://vk.com/club' + botModel.group_id +'?act=api&server=' + botModel.server_id"
                   target="_blank"
                   text
                   small
            >
                <span class="text-none">Перейти к настройкам ВК</span>
            </v-btn>
        </v-col>

        <select-group-vk-dialog
                :botId="botModel.id"
                :dialog="visSelectGroupVkDialog"
                :mailingParam="mailingParam"
                @close="visSelectGroupVkDialog = false"
        ></select-group-vk-dialog>

        <setting-group-vk-dialog
                :dialog="visSettingGroupVkDialog"
                :botId="botModel.id"
                @close="visSettingGroupVkDialog = false"
        ></setting-group-vk-dialog>

        <bot-form-connect-tg
                :botModel="botModel"
        ></bot-form-connect-tg>
        <bot-form-connect-wa
                :botModel="botModel"
        ></bot-form-connect-wa>
    </v-row>
</template>

<script>
import SelectGroupVkDialog from './SelectGroupVkDialog'
import SettingGroupVkDialog from './SettingGroupVkDialog'
import BotFormConnectTg from './BotFormConnectTg'
import BotFormConnectWa from './BotFormConnectWa'
import axios from 'axios'
import constConf from '../../../constconf'
export default {
    name: 'BotFormConnectVk',
    components: {
        SelectGroupVkDialog,
        SettingGroupVkDialog,
        BotFormConnectTg,
        BotFormConnectWa
    },
    data() {
        return {
            visSelectGroupVkDialog: false,
            visSettingGroupVkDialog: false,
            mailingParam: true
        }
    },
    props: ['botModel'],
    methods: {
        deleteCallbackServer() {
            axios.defaults.withCredentials = true
            axios.get(
                constConf.bot.url + '/bot/delete-callback-server/' + this.botModel.id
            )
                .then((response) => {
                    if (response.data.hasOwnProperty('success')) {
                        this.paramsSnackbar.color = 'success'
                        this.paramsSnackbar.text = response.data.success.text
                    } else {
                        this.paramsSnackbar.color = 'error'
                        this.paramsSnackbar.text = response.data.error.text
                    }
                    this.snackbar = true
                })
                .catch((error) => {
                    console.log('Ошибка при группы')
                    console.log(error)
                })
        },
        showSelectGroupDialog(mailingParam) {
            this.mailingParam = mailingParam
            this.visSelectGroupVkDialog = true
        }
    }
}
</script>

<style scoped>

</style>
